import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Handles redirects from static HTML pages (SEO support)
 * When static page redirects to /?redirect_to=/target, this component
 * intercepts it and navigates to the target route within the SPA
 */
const RedirectHandler = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const redirectTo = searchParams.get('redirect_to');

    useEffect(() => {
        if (redirectTo) {
            // Replace the current history entry so the back button works naturally
            // (user won't go back to the redirect trigger URL)
            navigate(redirectTo, { replace: true });
        }
    }, [redirectTo, navigate]);

    return null;
};

export default RedirectHandler;
